<template>
  <div class="flex items-center h-full px-2">
    <div class="flex-1">
      <div
        class="font-medium text-sm"
        :class="isSelected ? 'text-primary-700' : 'text-gray-900'"
      >
        <span class="sensitive">{{ params.data?.patient_name || 'Unknown' }}</span>
      </div>
      <div class="sensitive text-xs text-gray-500 mt-0.5">{{ params.data?.patient_identifier }}</div>
      <div class="text-xs text-orange-600 mt-0.5">{{ params.data?.open_gap_count || 0 }} open gaps</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quality_CompactPatientCell',
  props: ['params'],
  computed: {
    isSelected() {
      const parent = this.params.context?.componentParent;
      return this.params.data?.patient_identifier === parent?.selectedPatient?.patient_identifier;
    }
  }
};
</script>
